import React from 'react';
import GraphView from "../../GraphView";
import { inject, observer } from "mobx-react/index";
import { getDisplayDate } from "../../../libs/date";
import moment from 'moment';


@inject('stationStore', 'parameterStore')
@observer
class AnalysisDataViewGraph extends React.Component {

  insertMissingData = (observation, parameter_id, parameter_interval) => {
    const { missingTimestamps, dataSeriesItems } = this.props;
    const dataSeries = dataSeriesItems.find(item => item.id === parameter_id);
    let dataSeriesInterval = dataSeries && (dataSeries.interval || parameter_interval) * 60 * 1000;
    // let dataSeriesInterval = 15 * 60 * 1000; //min * sec * milli
    if (!dataSeriesInterval || !missingTimestamps) return observation;
    else {
      let data = [];
      let timeCounter = observation[0][0], endTime = observation[observation.length - 1][0];
      while (timeCounter <= endTime) {
        // eslint-disable-next-line
        let item = observation.find(item => Math.floor(item[0] / dataSeriesInterval) * dataSeriesInterval === Math.floor(timeCounter / dataSeriesInterval) * dataSeriesInterval);
        if (item) data.push(item);
        else data.push([timeCounter, null]);
        timeCounter += dataSeriesInterval;
      }
      return data;
    }
  }


  render() {
    const { data, selectedStations, selectedParameters } = this.props;

    let graphOptions = {
      chart: {
        zoomType: 'xy',
      },
      title: {
        text: 'Data Analysis'
      },
      xAxis: [{
        type: 'datetime',
        dateTimeLabelFormats: { // don't display the dummy year
          second: '%H:%M:%S',
        },
      }],
      yAxis: {
        title: {
          text: `values`
        },
      },
      tooltip: {
        shared: true
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        // enabled: false
      },
      series: []
    };
    
    data.forEach(station => {
      if (selectedStations[+station.id] === true && station.parameters) {
        station.parameters.map(parameter => {
          if (selectedParameters[+parameter.parameter_id] === true && !!parameter.data && !!parameter.data.length) {
            const observation = parameter.data.map(({ time, value }) => [getDisplayDate(time, { returnMills: true }), Math.round(value * 100) / 100]);
            graphOptions.series.push({
              name: `${station.name} ${parameter.parameter_code} (${parameter.parameter_unit_symbol})`,
              data: this.insertMissingData(observation, parameter.series_id, parameter.parameter_interval),
              // data: parameter.data.map(item => ([getDisplayDate(item.time, { returnMills: true }), Math.round(item.value * 100) / 100])),
              type: parameter.parameter_property === 'Accumulative' ? 'column' : 'line',
            })

            if (parameter.data2 && parameter.data2.length > 0) {
              ['avg', 'sum', 'min', 'max'].forEach(property => {
                const seriesData = parameter.data2.reduce((acc, item) => {
                  if (item[property] !== undefined) {
                    acc.push([
                      moment.utc(item.time).valueOf(),
                      parseFloat(item[property])
                    ]);
                  }
                  return acc;
                }, []).sort((a, b) => a[0] - b[0]);


                if (seriesData.length > 0) {
                  graphOptions.series.push({
                    name: `${station.name} ${parameter.parameter_code} (${parameter.parameter_unit_symbol}) - ${property.toUpperCase()}`,
                    data: this.insertMissingData(seriesData, parameter.series_id, parameter.parameter_interval),
                    type: parameter.parameter_property === 'Accumulative' ? 'column' : 'line',
                  });

                }
              }
              )
            }

          }
        });
      }
    });

    return (
      <div>
        <GraphView options={graphOptions} />
      </div>
    );
  }
}

export default AnalysisDataViewGraph;


// WEBPACK FOOTER //
// ./src/components/Analysis/Data/AnalysisDataViewGraph.js